// extracted by mini-css-extract-plugin
export default {"root":"ProfileLanguage_root__oF-2B","panel":"ProfileLanguage_panel__nLANx","wrapper":"ProfileLanguage_wrapper__TdS16","label":"ProfileLanguage_label__wSloH"};